import { useRef, useMemo } from "react";
import DataTableWrapper from "../../Utility/DataTableWrapper/DataTableWrapper";
import moment from "moment";
import { EventoService } from "../../../services/EventoService";
import { FormUtility } from "../../Utility/FormUtility";

export default function ProtocolloAudit(props) {

    const eventoService = new EventoService();
    const utility = new FormUtility();
    const dtRef = useRef();

    const dtOptions = useMemo(() => {
        return {
        columns: [
            {
                name: "Id",
                data: "id",
                visible: true,
                sortable: false,
                searchable: false,
            },
            {
                name: "Azione",
                data: "azione",
                visible: true,
                sortable: true,
                searchable: true,
            },
            {
                name: "Codice domanda",
                data: "oggetto",
                visible: true,
                sortable: true,
                searchable: false,
                cell: (row, col) => {
                    return row.oggetto.richiesta.codice;
                }
            },
            {
                name: "Tipo",
                data: "oggetto",
                visible: true,
                sortable: false,
                searchable: true,
                cell: (row, col) => {
                    return utility.getValueFromObj(row.oggetto, 'tipo');
                }
            },
            {
                name: "N° protocollo",
                data: "oggetto",
                visible: true,
                sortable: true,
                searchable: false,
                cell: (row, col) => {
                    return utility.getValueFromObj(row.oggetto, 'numeroProtocollo');
                }
            },
            {
                name: "Data protocollazione",
                data: "oggetto",
                visible: true,
                sortable: true,
                searchable: false,
                cell: (row, col) => {
                    if(!row.oggetto.dataProtocollo || row.oggetto.dataProtocollo == 0) return "";
                    return moment(row.oggetto.dataProtocollo).format("DD/MM/YYYY HH:mm:ss")
                }
            },
            {
                name: "Esito",
                data: "oggetto",
                visible: true,
                sortable: false,
                searchable: true,
                cell: (row, col) => {
                    return utility.getValueFromObj(row.oggetto, 'esito');
                }
            },
            // {
            //     name: "Impronta",
            //     data: "oggetto",
            //     visible: true,
            //     sortable: false,
            //     searchable: true,
            //     cell: (row, col) => {
            //         return utility.getValueFromObj(row.oggetto, 'impronta');
            //     }
            // },
            {
                name: "Errore",
                data: "oggetto",
                visible: true,
                sortable: false,
                searchable: true,
                cell: (row, col) => {
                    return utility.getValueFromObj(row.oggetto, 'errore');
                }
            },
            {
                name: "Data evento",
                data: "createdAt",
                visible: true,
                sortable: true,
                searchable: true,
                cell: (row, col) => {
                    return moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss");
                }
            }
        ],
        serverSide: true,
        rows: [],
        sorts: [],
        hideSearch: false,
        title: "Elenco eventi Protocollo",
        ajax: eventoService.getAllDt,
        ajaxParams: {
            entity: ["Protocollo"],
            // azione: [
            //     "SALVATAGGIO_PROTOCOLLO_PRESENTAZIONE", "SALVATAGGIO_PROTOCOLLO_ANNULLAMENTO", "SALVATAGGIO_RESCHEDULING_PROTOCOLLO_PRESENTAZIONE", "SALVATAGGIO_RESCHEDULING_PROTOCOLLO_ANNULLAMENTO",
            //     "SALVATAGGIO_ERRORE_PROTOCOLLO_PRESENTAZIONE", "SALVATAGGIO_ERRORE_PROTOCOLLO_ANNULLAMENTO", "SALVATAGGIO_ERRORE_RESCHEDULING_PROTOCOLLO_PRESENTAZIONE", "SALVATAGGIO_ERRORE_RESCHEDULING_PROTOCOLLO_ANNULLAMENTO",
            //     "SALVATAGGIO_PROTOCOLLO_AGGIORNAMENTO", "SALVATAGGIO_RESCHEDULING_PROTOCOLLO_AGGIORNAMENTO","SALVATAGGIO_ERRORE_PROTOCOLLO_AGGIORNAMENTO",
            //     "SALVATAGGIO_ERRORE_RESCHEDULING_PROTOCOLLO_AGGIORNAMENTO", "SALVATAGGIO_PROTOCOLLO_RETTIFICA_IBAN", "SALVATAGGIO_ERRORE_PROTOCOLLO_RETTIFICA_IBAN",
            //     "SALVATAGGIO_PROTOCOLLO_RINUNCIA", "SALVATAGGIO_ERRORE_PROTOCOLLO_RINUNCIA", "SALVATAGGIO_ERRORE_RESCHEDULING_PROTOCOLLO_RINUNCIA", "SALVATAGGIO_RESCHEDULING_PROTOCOLLO_RINUNCIA"
            // ],
            searchableItem: [
                "codice",
                "errore",
                "esito",
                "numeroProtocollo",
                "tipo"
            ]
        },
        };
    }, []);

    return (
        <DataTableWrapper
            ref={dtRef}
            dtOptions={dtOptions}
        />
    );
}
